// extracted by mini-css-extract-plugin
export default {"row":"styles_row__t71LA","maintitle":"styles_maintitle__BGt6w","searchCol":"styles_searchCol__ROuwO"};